import { api, apiRoutes } from "../../api"


export const fetchCheckUsername = async (username: string): Promise<boolean> => {
	const {data} = await api.post<{isExist: boolean}>(apiRoutes.checkUsername(), {username})
	return data.isExist
}